export const LOGIN_SUCCESS = "@User_LoginSuccess";
export const LOGIN_ERROR = "@User_LoginError";
export const LOGOUT = "@User_Logout";



// WEBPACK FOOTER //
// ./src/app/store/reducers/user/ActionsUserReducer.ts